import { Component, OnInit } from '@angular/core';
import { AppService } from 'src/app/app.service';
import { ToastrService } from 'ngx-toastr';
@Component({
  selector: 'app-microsoft-checkerrejform',
  templateUrl: './microsoft-checkerrejform.component.html',
  styleUrls: ['./microsoft-checkerrejform.component.scss']
})
export class MicrosoftCheckerrejformComponent implements OnInit {
public Microsoft360Final_data:any={};
  constructor(public appservice:AppService,public toastr:ToastrService) { }
onApprove(){
this.Microsoft360Final_data.status='Approved';
this.Microsoft360Final_data.approvedby=this.appservice.username;
   this.appservice.getTable("api/Transaction/Update_finalapproveMicrosoft360?empid="+this.Microsoft360Final_data.MD_EmployeeId+"&status="+this.Microsoft360Final_data.status+"&command="+this.Microsoft360Final_data.command+"&username="+this.Microsoft360Final_data.approvedby).subscribe((res:any)=>{
    this.toastr.success("Approved successfully!");
    this.appservice.get_Microsoft360_finalappgrid();
   });
  //this.appservice.checkeritfacilityedit='';
  //this.router.navigate(['/home/checkerreview'])
  this.appservice.goback();
}
back(){
  this.appservice.goback();
}
  onDecline(){
  if(this.Microsoft360Final_data.command=="" || this.Microsoft360Final_data.command==undefined){
    this.toastr.warning("The Commands Should not be empty","warning");
  }else{
    this.Microsoft360Final_data.status='Rejected';
    this.Microsoft360Final_data.approvedby=this.appservice.username;
    this.appservice.getTable("api/Transaction/Update_finalapproveMicrosoft360?empid="+this.Microsoft360Final_data.MD_EmployeeId+"&status="+this.Microsoft360Final_data.status+"&command="+this.Microsoft360Final_data.command+"&username="+this.Microsoft360Final_data.approvedby).subscribe((res:any)=>{
    this.toastr.success("Reject successfully!");
    this.appservice.get_Microsoft360_finalappgrid();
   });
  //this.appservice.checkeritfacilityedit='';
  //this.router.navigate(['/home/checkerreview'])
  this.appservice.goback();
  }
}
onformload(){
  this.appservice.Microsoft_checkRejecteditid
  this.appservice.getTable("api/Transaction/getMicrosoft360_finaleditdata?id="+this.appservice.Microsoft_checkRejecteditid).subscribe((res:any)=>{
    if(res!=""){
      this.Microsoft360Final_data=JSON.parse(res).record[0];
      console.log("the edit data of microsoft 360 final approver form",this.Microsoft360Final_data)
    }
  });
}
  ngOnInit(): void {
    this.onformload();
  }

}
